export const tableConstants = {
    ACTION_REMOVE: 'delete',
    ACTION_ACTIVATE: 'activate',
    ACTION_DEACTIVATE: 'deactivate',

    ACTION_ACTIVATE_ICON: 'check-circle',
    ACTION_DEACTIVATE_ICON: 'close-circle'
};
